import { h, inject, provide, ref } from 'vue'
import { VSnackbar } from 'vuetify/components'

export function createAlert () {
  const model = ref(false)
  const text = ref('')

  function alert (message: string) {
    text.value = message
    model.value = true
  }

  provide('alert', { alert })

  const Alert = () => h(VSnackbar, {
    modelValue: model.value,
    'onUpdate:modelValue': v => (model.value = v),
    color: 'success',
    timeout: 2000
  }, { default: () => text.value })

  return { model, text, Alert }
}

export function useAlert () {
  return inject('alert', { alert: (message: string) => null })
}
